import { IconButton } from "@circleco/compass/components/IconButton";
import { Tooltip } from "@circleco/compass/components/Tooltip";

import { t } from "@/i18n-js/instance";

interface ActionButtonProps {
  canSend: boolean;
  disabled?: boolean;
  isRunning: boolean;
  isStopping: boolean;
  isUploading?: boolean;
  isVoiceActive: boolean;
  onStop?: () => void;
  onSubmit: () => void;
  testId: string;
}

export const ActionButton = ({
  canSend,
  disabled,
  isRunning,
  isStopping,
  isUploading = false,
  isVoiceActive,
  onStop,
  onSubmit,
  testId,
}: ActionButtonProps) => {
  const tooltipContent = isRunning
    ? t("circle_ai_home.stop")
    : t(canSend ? "circle_ai_home.send" : "circle_ai_home.send_empty");

  const isDisabled = isRunning
    ? isVoiceActive || isStopping || !onStop
    : isVoiceActive || disabled || !canSend || isUploading;

  return (
    <Tooltip content={tooltipContent}>
      <IconButton
        icon={isRunning ? "stop-circle" : "arrow-up"}
        variant="primary"
        size="sm"
        data-testid={`${testId}-${isRunning ? "stop" : "send"}-button`}
        aria-label={t(
          isRunning ? "circle_ai_home.stop" : "circle_ai_home.send",
        )}
        loading={isStopping}
        disabled={isDisabled}
        onClick={isRunning ? onStop : onSubmit}
      />
    </Tooltip>
  );
};
